import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

// Create axios instance
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle token expiration and user type mismatches
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url || '';
    const isAuthEndpoint = /\/auth\//.test(url);

    if (status === 401 && isAuthEndpoint) {
      localStorage.removeItem('token');
      window.location.href = '/#/login';
    } else if (status === 403 && error.response?.data?.message?.includes('Access denied')) {
      localStorage.removeItem('token');
      alert('User type mismatch detected. Please log in with the correct account type.');
      window.location.href = '/#/login';
    }
    return Promise.reject(error);
  }
);

export const authService = {
  async login(email, password) {
    const response = await api.post('/auth/login', { email, password });
    return response.data;
  },

  async register(userData) {
    const response = await api.post('/auth/register', userData);
    return response.data;
  },

  async getProfile() {
    const response = await api.get('/auth/profile');
    return response.data;
  },

  async updateProfile(profileData) {
    const response = await api.put('/auth/profile', profileData);
    return response.data;
  },

  // Create pharmacy profile (for pharmacy users who need to complete setup)
  async createPharmacyProfile(profileData) {
    const response = await api.post('/pharmacy/profile', profileData);
    return response.data;
  },

  async logout() {
    localStorage.removeItem('token');
  },

  async forgotPassword(email) {
    const response = await api.post('/auth/forgot-password', { email });
    return response.data;
  },

  async resetPassword(token, password) {
    const response = await api.post('/auth/reset-password', { token, password });
    return response.data;
  }
};

export default api;
